import React, { useEffect } from 'react';
import { AuthInfo } from 'react-memory-optimization/dist/lib/store/user/types';
import { useAuth } from 'react-render-hooks';

import { useHookFabric } from 'hooks/useHookFabric';
import {
  getDomainsSelector,
  getTriggerSelector,
  setDomainsAction,
} from 'stores/sso/selectors';
import { useZustandSsoStore } from 'stores/sso/store';
import { Domain, EDomainTrigger, ZustandSsoEntity } from 'stores/sso/types';
import { IS_DEVELOPMENT_MODE } from 'constants/ui';
import { prepareForRedirect } from 'utils/shared';

type Props = {
  children: React.ReactElement;
};

const HOCSso = (props: Props) => {
  const { children } = props;

  const setDomains = useZustandSsoStore(setDomainsAction);

  const domains = useZustandSsoStore(getDomainsSelector);

  const trigger = useZustandSsoStore(getTriggerSelector);

  const isAuthInfo = useHookFabric<AuthInfo>({
    fn: useAuth,
  });

  useEffect(() => {
    if (!IS_DEVELOPMENT_MODE || !isAuthInfo) {
      return;
    }
    const fetching = async (tryCount: number) => {
      if (tryCount > 3) {
        return;
      }
      try {
        // const res = await fetch('/casino/mock/domains.json');
        const res = await fetch(
          'https://data.azufront.com/ref_service/api/v1/domains/list',
          {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${isAuthInfo.token}`,
            },
          }
        );

        const data = (await res.json()) as Domain[];

        setDomains(data);
      } catch (error) {
        fetching(tryCount + 1);
        console.log('🚀 ~ fetching ~ error:', error);
      }
    };

    fetching(1);
  }, [isAuthInfo]);

  useEffect(() => {
    if (
      isAuthInfo &&
      domains?.length &&
      trigger === EDomainTrigger.Immediately
    ) {
      prepareForRedirect();

      return;
    }
  }, [isAuthInfo, domains, trigger]);

  return children;
};

export default HOCSso;
